// src/reportWebVitals.js

export default function reportWebVitals(metric) {
    console.log(metric);
  }
  